export const styles = () => ({
  wrap: {
    position: 'absolute',
    width: 24,
    height: 24,
    background: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 2,
    boxSizing: 'border-box',
    borderRadius: '50%',
    overflow: 'hidden',
    right: -2,
    bottom: -2,
  },
  count: {
    width: '100%',
    height: '100%',
    background: '#FF6666',
    textAlign: 'center',
    borderRadius: '50%',
    fontSize: 12,
    lineHeight: '20px',
    color: '#fff',
    fontWeight: 700,
  },
})
